import * as React from 'react';
import { Box  } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import TextButtonComponet from '../../atom/Buttons/TextButton';

const isResumeAction = (action) => action === "fetch";

const QuizFirstCard = ({ onQuizStart, quizEntryAction }) => {
    const isResume = isResumeAction(quizEntryAction);
    return (<Box >
    <p className='announcement-subtext' style={{marginBottom:8}}>Welcome to the Quiz!</p>
    <p className='announcement-subtext' style={{marginBottom:8}}>Hello everyone!</p>
    <p className='announcement-subtext' style={{marginBottom:15}}>We’re glad you’re here! As you take the quiz, please approach each question thoughtfully, connecting keywords and applying concepts carefully. If you find any questions confusing, use the flagging feature to mark them for review later.</p>
    <p className='announcement-subtext' style={{marginBottom:15}}>At the end, you’ll receive a detailed report with your scores for each cluster, helping you see where you excel and where you can improve.</p>
    <p className='announcement-subtext' style={{marginBottom:15, fontWeight:700 }}>Note for Students</p>
    <p className='announcement-subtext' style={{marginBottom:15}}>Once you start the quiz, you won’t be able to click or navigate outside the quiz screen. All other controls will remain disabled until you complete and submit the quiz.</p>
    <p className='announcement-subtext' style={{marginBottom:15}}>Please make sure you begin only when you’re ready to stay focused till the end</p>

    <p className='announcement-subtext'>Good luck, and do your best! We believe in you!</p>
    <Box sx={{ paddingTop: 5, width: { xs: 1, md: 0.2 } }}>
      {isResume ? (
        <button
          type="button"
          className="btn btn-resume-quiz"
          onClick={onQuizStart}
        >
          <PlayCircleOutlineIcon className="btn-resume-quiz__icon" />
          Resume Quiz
        </button>
      ) : (
        <TextButtonComponet onButtonClick={onQuizStart} text="Start Quiz" />
      )}
</Box>
    
    </Box>);
}

export default QuizFirstCard;